import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { ProdOrderCommandType } from './prod-order-command'

@Directive({
  selector: '[appProdOrderCommandSelect]',
})
export class ProdOrderCommandSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject(ElderSelectComponent)
  private enumDataSourceFactory = inject(ElderEnumTranslationService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'displayValue'
    this.select.placeholder = 'commands.title'
    this.select.nullDisplay = 'context.noSelection'
    this.select.dataSource = this.enumDataSourceFactory.enumDataSource(
      ProdOrderCommandType,
      'prod_order_commands'
    )
  }
}
